<template>
    <div class="dashboard-component" id="success">
        <div class="banner success-banner">
            <container>
                <header>
                    <div class="inner">
                        <grid horizontal="left">
                            <grid-item size="2/12" class="pointer logo-opacity">
                                <a href="/">
                                    <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span>
                                </a>
                            </grid-item>

                            <grid-item size="10/12" class="nav-items">
                                <ul class="top-menu">
                                    <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                    <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                    <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                </ul>
                            </grid-item>


                        </grid>
                    </div>
                </header>
                <div class="banner-content">
                    <h1 class="white-text">Congratulations!</h1>
                    <h2 class="white-text">Your vendor ID is {{vendorid}}</h2>
                    <grid horizontal="left" class="vl-rltv">
                        <grid-item size="8/12" class="zindex101">
                            <h3 class="banner-text-normal white-text">A verification mail has been sent to <strong>{{email}}</strong>.</h3>
                            <h4 class="banner-text-normal white-text">{{message}}</h4>
                            <button v-bind:class="buttonclass" type="button" @click="resendVerificationMail()">RESEND VERIFICATION MAIL</button>
                        </grid-item>
                        <grid-item  size="4/12" class="v-middle right zindex101 vl-bnr-top-ico">
                            <img class="v-middle right width60" src="../assets/images/gfx-bot.svg">

                        </grid-item>
                    </grid>

                </div>
            </container>
        </div>

        <div class="success-basic">
            <container >
                <p class="center success-p">Please follow the link in mail to verify.</p>
                <p class="center success-p">Post verification - your <strong>{{planData.planname}}</strong> plan shall be activated and  you shall receive details to sign in to vendor console and upload content.</p>
                <p class="center success-p">You shall receive iOS, Android and Web Apps in next 24 hours. </p>
                <p class="center success-p">Please test and let us know when you ready to go live.</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <div class="success-back-color blk-pad">
            <container >
                <p class="center success-help m-0">Need Help?</p>
                <p class="center success-p m-0 p-top-10">Please contact us at <strong>vlitesupport@mobiotics.com</strong></p>
                <p class="center success-p m-0 p-top-10">citing your vendor id <strong>({{vendorid}})</strong> for any help.</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <!--Footer-->
        <footer class="page-footer">
            <div class="footer-color">
                <container>
                    <grid>
                        <grid-item size="4/12">
                            <div class="vl-foot-left">
                                <div class=" logo-opacity">
                                    <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;"></a>
                                </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                            <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                            <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                                <ul>
                                    <li><a href="#">Terms of use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div> -->
                        </grid-item>
                    </grid>
                </container>
            </div>
        </footer>
        <!-- basic -->
        <container>
        <div class="dash-loader" id="dash-loader" v-if ="loaderStatus">
            <div class="dash-loader-img">
                <svg class="lds-spin" width="100px"  height="100px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(80,50)">
                <g transform="rotate(0)">
                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="1" transform="scale(1.045 1.045)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.8333333333333334s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.8333333333333334s"></animate>
                </circle>
                </g>
                </g><g transform="translate(65,75.98076211353316)">
                <g transform="rotate(59.99999999999999)">
                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.8333333333333334" transform="scale(1.06167 1.06167)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.6666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.6666666666666666s"></animate>
                </circle>
                </g>
                </g><g transform="translate(35.00000000000001,75.98076211353316)">
                <g transform="rotate(119.99999999999999)">
                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.6666666666666666" transform="scale(1.07833 1.07833)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate>
                </circle>
                </g>
                </g><g transform="translate(20,50.00000000000001)">
                <g transform="rotate(180)">
                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="0.5" transform="scale(1.095 1.095)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.3333333333333333s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.3333333333333333s"></animate>
                </circle>
                </g>
                </g><g transform="translate(34.999999999999986,24.019237886466847)">
                <g transform="rotate(239.99999999999997)">
                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.3333333333333333" transform="scale(1.01167 1.01167)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.16666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.16666666666666666s"></animate>
                </circle>
                </g>
                </g><g transform="translate(65,24.019237886466843)">
                <g transform="rotate(300.00000000000006)">
                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.16666666666666666" transform="scale(1.02833 1.02833)">
                  <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
                </circle>
                </g>
                </g>
            </svg>
            </div>
        </div>
    </container>

    </div>



</template>

<script>
const { Config } = require('../assets/js/config.js');

    export default{
        data(){
            return{
                vendorid:313786,
                email: 'quizzertv@gmail.com',
                planname: 'CLASSIC',
                planData:{},
                message:'Don’t see your verification mail?',
                buttonclass: ['btn','banner-get-btn-success'],
                loaderStatus: false,
                apibaseurl:'',
                vendorportalurl:''
            };
        },
        created () {
            this.planData = this.$route.params.plandata;
            this.vendorid = this.$route.params.vendorid;
            this.email = this.$route.params.email;
        },
        mounted() {
                // Setting Config URLs
                var con = new Config()
                this.apibaseurl = con.getApiUrl();
                this.vendorportalurl = con.getPortalUrl();
                this.$scrollTo('#success');

                var thisYear  = new Date().getFullYear();
                console.log(document.getElementById('copyrightyear'));
                document.getElementById('copyrightyear').innerHTML = thisYear;
        },
        methods: {
            openSocialNewTab(surl){
                window.open(surl, '_blank');
            },
            navigateToHomeWithDiv(divname){
                this.$router.push({ name: 'Home', params: { divid: divname}});
            },
            openNewTab() {
                window.open(this.vendorportalurl, '_blank');
            },
            resendVerificationMail(){
                this.loaderStatus = false;
                // var url = 'vpremieretest.mobiotics.com/vendor/v1/plan';
                var hurl = this.apibaseurl+'/vendor/v1/signup/emailresend?email='+this.email;
                var payload = {};
                var protocol = window.location.protocol;
                this.$http({url: hurl, payload: payload, method: 'GET'}).then(function (response) {
                    console.log('Success!:', response);
                    this.buttonclass = ['btn','banner-get-btn-success','hidden'],
                    this.message = "Verification Mail Resend Successfull, Please Check Mail.";
                    //this.plans = response.data;
                    this.loaderStatus = false;
                }, function (response) {
                    console.log('Error!:', response);
                    this.loaderStatus = false;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Success.vue